// UTM helper for the Thales landing page.
// Adds utm_source=thales / utm_medium=landing / utm_campaign=thales-landing
// to any http(s) URL. Leaves mailto:, tel:, anchors and relative URLs untouched.

const UTM_PARAMS: Record<string, string> = {
  utm_source: "thales",
  utm_medium: "wl",
  utm_campaign: "thales-wl",
};

export const withUtm = (href: string): string => {
  if (!href) return href;
  if (!/^https?:\/\//i.test(href)) return href;
  try {
    const url = new URL(href);
    Object.entries(UTM_PARAMS).forEach(([k, v]) => {
      if (!url.searchParams.has(k)) {
        url.searchParams.set(k, v);
      }
    });
    return url.toString();
  } catch {
    return href;
  }
};
